import { BlobStorageAccess } from './auth.module';

export function assertBlobConfig(
  config: BlobStorageAccess | undefined,
): asserts config is BlobStorageAccess {
  const err = "'Blob storage access configuration is not defined!";
  if (
    !config?.upload?.sas ||
    !config?.upload?.url ||
    !config?.download?.sas ||
    !config?.download?.url
  )
    throw new Error(err);
}
